/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getReservations = /* GraphQL */ `query GetReservations {
  getReservations {
    ReservationHash
    Sub
    ReservationDate
    AppointmentData
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReservationsQueryVariables,
  APITypes.GetReservationsQuery
>;
export const getPatientCards = /* GraphQL */ `query GetPatientCards($hospitalName: String) {
  getPatientCards(hospitalName: $hospitalName) {
    cardId
    hospitalName
    patientCardNumber
    patientBirth
    nickname
    createdAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPatientCardsQueryVariables,
  APITypes.GetPatientCardsQuery
>;

export const getReservationsPage = /* GraphQL */ `query GetReservationsPage($nextToken: String) {
  getReservationsPage(nextToken: $nextToken) {
    items {
      ReservationHash
      Sub
      ReservationDate
      AppointmentData
      Status
      ResultMessage
      ReceiptNumber
      ResultUpdatedAt
      StartedAt
    }
    nextToken
  }
}` as GeneratedQuery<APITypes.GetReservationsPageQueryVariables, APITypes.GetReservationsPageQuery>;
